import SanitizedHtml from '../../SanitizedHtml/SanitizedHtml';
import './CmsActivity.css';

interface CmsActivityProps {
	image: string;
	imageTitle: string;
	imageText: string;
	content: string;
	ctaLink: string;
	ctaText: string;
	backgroundColor: string;
}

export const CmsActivity = ({
	image,
	imageTitle,
	imageText,
	content,
	ctaLink,
	ctaText,
	backgroundColor,
}: CmsActivityProps): JSX.Element => {
	return (
		<section className={`cms-activity`}>
			{image && (
				<div className="cms-activity__image" style={{ ['background-color' as string]: backgroundColor }}>
					{imageTitle && <h2 className="cms-activity__image-title">{imageTitle}</h2>}
					{imageText && <p className="cms-activity__image-text">{imageText}</p>}
					<div
						className="cms-activity__image-media"
						style={{ ['background-image' as string]: `url(${image})` }}
						aria-hidden="true"
					/>
				</div>
			)}
			<div className="cms-activity__body">
				{content && <SanitizedHtml html={content} className="cms-activity__content" />}
				{ctaLink && ctaText && (
					<a className="cms-activity__cta" href={ctaLink}>
						{ctaText}
					</a>
				)}
			</div>
		</section>
	);
};
